import ajax from "../utils/request";
const voteApi = {
  /********************************AI交易列表*********************************** */
  // 请求AI交易列表
  getAiTransList(params) {
    return ajax({
      url: '/ai/undress/list',
      type: 'get',
      params: params
    })
  },
  // AI交易审核
  aiTransExamine(params) {
    return ajax({
      url: '/ai/undress/update',
      type: 'post',
      params: params
    })
  },
  // AI交易自动处理
  aiTransAuto(params) {
    return ajax({
      url: '/ai/undress/auto',
      type: 'post',
      params: params
    })
  },
  /********************************AI图片换脸交易列表*********************************** */
  // 请求AI图片换脸交易列表
  getAiImgTransList(params) {
    return ajax({
      url: '/ai/change_face_img/list',
      type: 'get',
      params: params
    })
  },
  // AI图片换脸交易审核
  aiImgTransExamine(params) {
    return ajax({
      url: '/ai/change_face_img/update',
      type: 'post',
      params: params
    })
  },
  /********************************AI换脸模版*********************************** */
  // 获取AI换脸模版列表
  getChangeFaceModList(params) {
    return ajax({
      url: "/ai/changeface/mod/list",
      type: "get",
      params: params,
    });
  },
  // 添加AI换脸模版
  addChangeFaceMod(params) {
    return ajax({
      url: "/ai/changeface/mod/add",
      type: "post",
      params: params,
    });
  },
  // 修改AI换脸模版
  updateChangeFaceMod(params) {
    return ajax({
      url: "/ai/changeface/mod/update",
      type: "post",
      params: params,
    }, true);
  },
  // 获取AI换脸交易列表
  getChangeFaceList(params) {
    return ajax({
      url: "/ai/changeface/list",
      type: "get",
      params: params,
    });
  },
  // 编辑AI换脸交易列表
  updChangeFaceList(params) {
    return ajax({
      url: "/ai/changeface/update",
      type: "post",
      params: params,
    });
  },
  // 给用户添加AI换脸折扣券
  addUserAiChangeFaceDiscount(params) {
    return ajax({
      url: "/user/generate/aiChangeFaceDiscount",
      type: "post",
      params: params,
    });
  },
  // 查询AI换脸折扣券奖品列表
  getAiChangeFaceDiscountList() {
    return ajax({
      url: "/user/gainAiPrize",
      type: "get",
    });
  },
};
export default voteApi;
